import React from 'react'
import { useDispatch } from 'react-redux'
import { openModal, closeModal } from 'actions/modalActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import StandardModalContent from '../StandardModalContent/StandardModalContent.jsx'
import HelpModal from './HelpModal.jsx'
import PropTypes from 'prop-types'

const HelpSubmenu = props => {
  const dispatch = useDispatch()

  function aboutModal() {
    dispatch(openModal('about_modal', {
      title: 'About',
      content: (
        <StandardModalContent
          messageContent={<HelpModal/>}
          okHandler={() => {
            dispatch(closeModal('about_modal'))
          }}
          okText={'OK'}
        />
      ),
      closeable: true
    }))
  }

  function goToSupport() {
    window.open('https://xtract.freshdesk.com/support/home', '_blank')
  }

  return (
    <li className="dropdown-submenu">
      <a
        className="dropdown-toggle"
        id="helpDropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="true"
        role="button"
        aria-labelledby="help menu"
      >
        <FontAwesomeIcon icon={['fas', 'question-circle']} />
        Help
      </a>
      <ul
        className="dropdown-menu dropdown-menu-right"
        aria-labelledby="help menu"
      >
        <li>
          <a
            role="button"
            aria-label={'about link'}
            onClick={e => {
              e.preventDefault()
              aboutModal()
            }}
          >
            About
          </a>
        </li>
        <li>
          <a
            role="button"
            aria-label={'support link'}
            onClick={e => {
              e.preventDefault()
              goToSupport()
            }}
          >
            Get Support
          </a>
        </li>
      </ul>
    </li>
  )
}

HelpSubmenu.propTypes = {
  disabled: PropTypes.bool
}

export default HelpSubmenu
